import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const LANGS = ["de", "en", "fr", "es"];
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("po_lang");
    return LANGS.includes(saved) ? saved : "de";
  });

  useEffect(() => {
    localStorage.setItem("po_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
